import React from 'react';
import { useUIStore } from 'store/uiStore';
import { LoadingOverlay, Spinner } from './Spinner';

export const GlobalLoadingWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loading } = useUIStore();

  return (
    <>
      {children}
      {loading.isLoading && loading.loadingType === 'overlay' && (
        <LoadingOverlay 
          message={loading.loadingMessage} 
          showSpinner={true}
          effect="solid"
          withBackground={false}
        />
      )}
    </>
  );
};

interface LoadingWrapperProps {
  children: React.ReactNode;
  operationId?: string;
  fallback?: React.ReactNode;
  type?: 'overlay' | 'inline' | 'button';
  withBackground?: boolean;
  withBlur?: boolean;
  effect?: 'blur' | 'fade' | 'glass' | 'minimal' | 'elegant' | 'soft' | 'premium' | 'gentle' | 'modern';
}

export const LoadingWrapper: React.FC<LoadingWrapperProps> = ({ 
  children, 
  operationId, 
  fallback,
  type = 'inline',
  withBackground = false,
  withBlur = true,
  effect = 'soft'
}) => {
  const { loading, loadingOperations } = useUIStore();
  
  const isLoading = operationId 
    ? loadingOperations.get(operationId)?.isLoading || false
    : loading.isLoading;
    
  const loadingMessage = operationId 
    ? loadingOperations.get(operationId)?.loadingMessage || 'Loading...'
    : loading.loadingMessage || 'Loading...';

  if (isLoading) {
    if (fallback) {
      return <>{fallback}</>;
    }
    
    if (type === 'overlay') {
      return <LoadingOverlay message={loadingMessage} withBackground={withBackground} withBlur={withBlur} effect={effect} />;
    }
    
    if (type === 'inline') {
      return (
        <div className="flex items-center justify-center">
          <div className="flex items-center gap-2">
            <Spinner size="sm" />
            <span className="text-sm text-secondary-600 dark:text-secondary-300">{loadingMessage}</span>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
};
